import React, { useState } from 'react';
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Patient1 from '../../images/patient1-big.png';
import dots from '../../images/dots.svg';
import { Link } from 'react-router-dom';

const Prescription = () => {
    const [height, setHeight] = useState(0);

    const medicine = [
        {
            name: "Salbair Transhaler",
            mcg: "50mcg",
            schedule: {
                morning: "2Tablet",
                evening: "2Tablet",
                night: "2Tablet"
            },
            duration: "1 week"
        },
        {
            name: "Vibramicine",
            mcg: "500mcg",
            schedule: {
                morning: "2Tablet",
                evening: "",
                night: "3Tablet"
            },
            duration: "1 day"
        }
    ];


    const medicineRow = () => {
        return medicine.map((el, i) => {
            return <div className="row" key={i}>
                <div className="col-lg-3 position-relative">
                    <div className="prescription-dropdown hide_on_large">
                        <div className="dropdown">
                            <span className="dropbtn p-2">
                                <img src={dots} alt="dots" />
                            </span>
                            <div className="dropdown-content">
                                <Link to="/prescription">Edit</Link>
                                <Link to="/prescription">Delete</Link>
                            </div>
                        </div>
                    </div>
                    <span className="h2desc font-weight-bold hide_on_large">Medicine Name</span>

                    <span className="h2desc">{el.name}</span>
                    <p className="h4desc">{el.mcg}</p>
                </div>
                <div className="col-lg-6">
                    <span className="h2desc font-weight-bold hide_on_large">Dosage</span>
                    <div className="row px-2">
                        {el.schedule.morning ?
                            <div className="col-lg-4 col-4 col-md-4">
                                <span className="h3desc">{el.schedule.morning}</span>
                                <p className="h4desc">Morning</p>
                            </div>
                            : ""}
                        {el.schedule.evening ?
                            <div className="col-lg-4 col-4 col-md-4">
                                <span className="h3desc">{el.schedule.evening}</span>
                                <p className="h4desc">Evening</p>
                            </div>
                            : ""}
                        {el.schedule.night ?
                            <div className="col-lg-4 col-4 col-md-4">
                                <span className="h3desc">{el.schedule.night}</span>
                                <p className="h4desc">Night</p>
                            </div>
                            : ""}
                    </div>
                </div>
                <div className="col-lg-2">
                    <span className="h2desc font-weight-bold hide_on_large">Duration</span>
                    <span className="h2desc">{el.duration}</span>
                </div>
                <div className="col-lg-1">
                    <div className="dropdown hide_on_med">
                        <span className="dropbtn p-2">
                            <img src={dots} alt="dots" />
                        </span>
                        <div className="dropdown-content">
                            <Link to="/prescription">Edit</Link>
                            <Link to="/prescription">Delete</Link>
                        </div>
                    </div>
                </div>
            </div>
        })
    }

    return (
        <div>
            <Header setHeight={setHeight} />
            <div
                className="profile_crumb"
                style={{ height: height + 10 + "px" }}>
            </div>
            <div className="profile_page pb-5">
                <section className=" prescription-header-pad">
                    <div className="container prescription-header-pad mt-5">
                        <div className="w-80 prescription-pad bg-white shadow rounded_outer mx-auto">
                            <div className="pb-3 px-2 pt-3">

                                <div className="row pb-5 border-bottom">
                                    <h2 className="h4heading w-100 font-weight-bold responsive-center py-3 hide_on_large">Patient Details</h2>

                                    <div className="col-lg-2 prescription-align-right responsive-center">
                                        <img src={Patient1} alt="profile" />
                                    </div>
                                    <div className="col-lg-10 ">
                                        <h2 className="h4heading font-weight-bold hide_on_med">Patient Details</h2>
                                        <div className="row py-3">
                                            <div className="col-lg-3 col-sm-6 col-6 col-md-6">
                                                <span className="h3desc">Patient Name</span>
                                                <p className="h3desc font-weight-bold">John Doe</p>
                                            </div>
                                            <div className="col-lg-3 col-sm-6 col-6 col-md-6">
                                                <span className="h3desc">Age</span>
                                                <p className="h3desc font-weight-bold">47</p>
                                            </div>
                                            <div className="col-lg-3 col-sm-6 col-6 col-md-6">
                                                <span className="h3desc">Sex</span>
                                                <p className="h3desc font-weight-bold">Male</p>
                                            </div>
                                            <div className="col-lg-3 col-sm-6 col-6 col-md-6">
                                                <span className="h3desc">Mobile Number</span>
                                                <p className="h3desc font-weight-bold">+880 123 3456</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row d-flex align-items-center position-relative">
                                    <div className="col-lg-7 prescription-left">
                                        <p className="h4heading font-weight-bold responsive-center pt-5">Digital Description Form</p>

                                        <div className="row py-2">
                                            <div className="col-lg-8">
                                                <h6 className="h3desc">Medicine Name</h6>
                                                <div className="form_input">
                                                    <input className="form-control py-2 h-auto" placeholder="Medicine Name" type="text" id="medicine" required />
                                                    <label className="ml-3" htmlFor="medicine">
                                                        Medicine Name </label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <h6 className="h3desc">Potency</h6>
                                                <div className="form_input ">
                                                    <input className="form-control py-2 h-auto" placeholder="Potency" type="text" id="potency" required />
                                                    <label className="ml-3" htmlFor="potency">
                                                        Potency </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row py-2">
                                            <div className="col-lg-4">
                                                <h6 className="h3desc">Dosage</h6>
                                                <div className="form_input ">
                                                    <input className="form-control py-2 h-auto" placeholder="Dosage" type="text" id="dosage" required />
                                                    <label className="ml-3" htmlFor="dosage">
                                                        Dosage </label>
                                                </div>
                                            </div>
                                            <div className="col-lg-8">
                                                <h6 className="h5heading ">Frequency</h6>
                                                <div className="row">
                                                    <div className="col-lg-6 col-6 col-md-6">
                                                        <label className="form-check-label h3desc chk-container" htmlFor="morning">
                                                            <input className="form-check-input" type="checkbox" id="morning" value="option1" />
                                                            <span className="chk-checkmark"></span>
                                                            Morning </label>
                                                    </div>
                                                    <div className="col-lg-6 col-6 col-md-6">
                                                        <label className="form-check-label h3desc chk-container" htmlFor="aftermnoon">
                                                            <input className="form-check-input" type="checkbox" id="aftermnoon" value="option1" />
                                                            <span className="chk-checkmark"></span>
                                                            Aftermnoon </label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6 col-6 col-md-6">
                                                        <label className="form-check-label h3desc chk-container" htmlFor="Evening">
                                                            <input className="form-check-input" type="checkbox" id="Evening" value="option1" />
                                                            <span className="chk-checkmark"></span>
                                                            Evening </label>
                                                    </div>
                                                    <div className="col-lg-6 col-6 col-md-6">
                                                        <label className="form-check-label h3desc chk-container" htmlFor="night">
                                                            <input className="form-check-input" type="checkbox" id="night" value="option1" />
                                                            <span className="chk-checkmark"></span>
                                                            Night </label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <h6 className="h3desc">Duration</h6>
                                        <div className="form_input">
                                            <input className="form-control py-2 h-auto" placeholder="Enter duration" type="text" id="duration" required />
                                            <label className="ml-3" htmlFor="duration">
                                                Enter duration </label>
                                        </div>
                                        <div className="text-center">
                                            <button className="w-100 py-2 mt-4 mb-1 active h3desc tableButton">ADD ANOTHER MEDICINE</button>
                                        </div>
                                        <div className="or-center hide_on_large">OR</div>
                                    </div>
                                    <div className="or-center hide_on_med">OR</div>
                                    {/* left section end */}

                                    <div className="col-lg-5 px-5 prescription-right">
                                        <p className="h4heading font-weight-bold responsive-center py-2">Upload Prescription</p>
                                        <div className=" text-center border rounded position-relative drop">
                                            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                                                <h2 className="h2desc">Drop files here</h2>
                                                <h2 className="h2desc">OR</h2>
                                                <label className="form-check-label h2desc" style={{ color: "#25BCA7" }} htmlFor="file">
                                                            <input style={{visibility: "hidden"}}  readOnly className="form-check-input" type="file" id="file" value="" />
                                                            Browse and Upload file </label>
                                                {/* <h2 className="h2desc" style={{ color: "#25BCA7" }}>Browse and Upload file</h2> */}
                                            </div>
                                        </div>
                                        {/* right section end */}

                                    </div>
                                    {/* section row end */}
                                </div>

                                {/* digital prescription */}
                                <div className="digital-prescription pt-5">
                                    <p className="h4heading font-weight-bold responsive-center pt-4 pb-2">Digital Prescription</p>

                                    <div className="digital-prescription-head hide_on_med">
                                        <div className="row">
                                            <div className="col-lg-3">
                                               <span className="h2desc font-weight-bold">Medicine Name</span>
                                            </div>
                                            <div className="col-lg-6">
                                                <span className="h2desc font-weight-bold">Dosage</span>
                                            </div>
                                            <div className="col-lg-2">
                                                <span className="h2desc font-weight-bold">Duration</span>
                                            </div>
                                            <div className="col-lg-1"></div>
                                        </div>
                                    </div>
                                    <div className="digital-prescription-body">
                                        {medicineRow()}
                                    </div>
                                </div>
                                <div className="text-center responsive-border">
                                    <button className="prescription-button py-2 mt-5 mb-1 active h3desc tableButton">SEND PRESCRIPTION</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Prescription;